import type { SrcOptions as KitSrcOptions } from '@imagekit/javascript';
import { buildSrc as kitBuildSrc } from '@imagekit/javascript';

import { getEnvVar } from '@/shared/utils/envVarConfig';

const imageKitId = getEnvVar('VITE_IMAGEKIT_ID');
export const imageKitUrlEndpoint = `https://ik.imagekit.io/${imageKitId}/duos`;

type SrcOptions = Omit<KitSrcOptions, 'urlEndpoint'> & {
  urlEndpoint?: string;
};

export const buildSrc = (opts: SrcOptions) =>
  kitBuildSrc({ urlEndpoint: imageKitUrlEndpoint, ...opts });
export type { Transformation } from '@imagekit/javascript';
